<template>
  <div class="comment">
    <!-- <navigator title="发布评论" :routePath='`/bbs/detail/${id}`'></navigator> -->

    <p class="title">{{detail.subject}}</p>

    <p class="comments">全部评论  ({{detail.comments}})</p>
    <div class="avatar_wrap">
      <mt-cell class='cell_nomarginpadding' title="添加封面图片"></mt-cell>
      <van-uploader :after-read="onRead">
        <div class="box" v-if='!article.cover'>
          <i class="iconfont icon-shangchuantupian"></i>
        </div>
        <img v-else :src="article.cover" class="success">
      </van-uploader>
    </div>
    <mt-field class='commentinput' placeholder="请输入评论内容" type="textarea" rows="4" v-model="commentValue"></mt-field>

    <div class='footer'>
      <mt-button @click.native='commentRequest'>发布评论</mt-button>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { Toast } from 'vant';

export default {
  data() {
    return {
      id: '',
      newtoken:'',
      detail: {},
      commentValue: '',
      duration: 1500,
      article: {
        title: '',
        cover: '',
        content: '',
      },
    };
  },
  methods: {
    getDetail() {
      this.$http.post(`${this.URL_PREFIX}/app/get/bbs/post/detail`, {
        id: this.id,
      }, {
        headers: { token: localStorage.getItem('swtoken') }
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.detail = res.resData;
        }
      });
    },
    // 获取七牛配置
    getUploadToken() {
      this.$http.post(`${this.URL_PREFIX}/app/get/qiniu/bucket/token`, {}, {
        headers: { token: localStorage.getItem('swtoken') },
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.qiniuConfig = res.resData;
        }
      });
    },
    onRead(uploader) {
      let param = new FormData();
      param.append('file', uploader.file);
      param.append('token', this.qiniuConfig.token);
      let config = {
        headers:{'Content-Type':'multipart/form-data'}
      };
      this.$http.post('http://up-z2.qiniup.com/', param, config).then((response) => {
        const res = response.data;
        this.article.cover = `${this.qiniuConfig.domain}/${res.key}`;
      });
    },
    // 评论请求
    commentRequest() {
      if (!this.commentValue) {
        Toast.fail({ duration: this.duration, message:  '评论内容不能为空'});
        return;
      }
      this.$http.post(`${this.URL_PREFIX}/app/added/bbs/comments`, {
        content: this.commentValue,
        postId: this.id,
        thumb: this.article.cover,
      }, {
        headers: { token: localStorage.getItem('swtoken') }
      }).then((response) => {
        const res = response.data;
        this.commentValue = '';
        if (res.resCode === '10000') {
          Toast.fail({ duration: this.duration, message:  '评论成功'});
          // this.$router.push(`/bbs/detail/${this.id}`);
          window.location.href = `${this.URL_PREFIX_PAGE}/bbs/detail/${this.id}?orderId=${location.href.split('orderId=')[1]}`;
        } else {
          Toast.fail({ duration: this.duration, message:  res.resDesc});
        }
      });
    },
  },
  computed: {
    ...mapGetters(['token']),
  },
  created() {
    this.id = this.$route.params.postId;
    this.newtoken = this.$route.query.newtoken;
    // console.log(this.$route.query.newtoken);
    // console.log(localStorage.getItem('swtoken'));
    // if (!this.newtoken) {
    //   this.$root.eventHub.$emit('login', this.$route.fullPath);
    // } else {
    //   this.getDetail();
    // }
    this.getDetail();
    this.getUploadToken();
  },
};
</script>

<style lang="scss" scoped>
@import '~@scss';
.comment{
  .title{
    padding: .32rem;
    margin-bottom: .16rem;
    background: #fff;
    font-size: .4rem;
    line-height: .64rem;
    color: rgb(102, 102, 102);
    font-weight: 600;
    text-align: center;
    white-space: normal;
    word-break: break-all;
  }
    .avatar_wrap{
    padding: 0 .32rem .32rem .32rem;
    margin-bottom: .266667rem;
    background: #fff;
    .box{
      width: 2.24rem;
      height: 2.24rem;
      border: 1px solid rgb(200, 200, 200);
      line-height: 2.24rem;
      text-align: center;
      .iconfont{
        font-size: .8rem;
        color: rgb(200, 200, 200);
      }
    }
    .success{
      width: 2.24rem;
      height: 2.24rem;
    }
  }
  .comments{
    padding-left: .32rem;
    margin-bottom: .16rem;
    background: #fff;
    font-size: .32rem;
    line-height: .64rem;
    color: rgb(102, 102, 102);
  }
  .mint-field, .mint-cell{
    font-size: .4rem;
    color: rgb(67, 67, 67);
  }
   .footer{
     padding: px2rem(16) px2rem(24);
     background-color: #f5f5f5;
    margin-top: .4rem;
    box-sizing: border-box;
    width: 100%;
    .mint-button{
      width: 100%;
      height: 1.04rem;
      background: $color-main;
      color: #fff;
      font-size: .48rem;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/bbs/components/PublishComment.vue